export function* commonScrollPage({ x, y }) { // eslint-disable-line import/prefer-default-export
  if (typeof window !== 'undefined') {
    window.scrollTo(x, y)
  }
  yield
}



/** WEBPACK FOOTER **
 ** ./src/sagas/common/common-sagas.js
 **/